import { Tab } from "@headlessui/react";

function TabPanels({ children }) {
  return <Tab.Panels>{children}</Tab.Panels>;
}

export default TabPanels;
